import React from "react";
import { InvalidPaymentInfoTemplate } from "themes/application/payment/components";

function InvalidPaymentInfo(props) {
    return <InvalidPaymentInfoTemplate {...props} />;
}

export default InvalidPaymentInfo;
